import { ChannelModel } from '../models/ChannelModel'

const collator = new Intl.Collator('pt-BR', {sensitivity: 'base', numeric: true})

/**
 * Ordem da listagem de canais: ativos primeiro e, dentro de cada bloco, pelo
 * canal (nome real, ex.: "Mercado Livre") e só depois pelo nome que o usuário
 * deu. Assim as contas do mesmo canal ficam juntas, independente do batismo.
 */
export function sortChannelsForList(channels: ChannelModel[]): ChannelModel[] {
    return [...channels].sort((a, b) => {
        if (a.isActive !== b.isActive) {
            return a.isActive ? -1 : 1
        }

        return collator.compare(a.getRealName(), b.getRealName())
            || collator.compare(a.name || '', b.name || '')
    })
}

interface ChannelLike {
    id?: any
    isActive?: boolean
    name?: string
    getRealName?: () => string
}

interface StoreChannelLike {
    idChannel?: any
    channel?: ChannelLike
}

/**
 * Canais de um produto (vínculo produto x loja x canal) separados pelo estado
 * do canal nas configurações e na mesma ordem da listagem de canais. O estado
 * vem de `channelList` (canais configurados); canal fora dela conta como ativo,
 * para não esconder nada sem certeza.
 */
export function splitStoreChannelsByChannelState<T extends StoreChannelLike>(storeChannels: T[], channelList: ChannelLike[]): {active: T[], inactive: T[]} {
    const configuredById = new Map((channelList || []).map((c) => [String(c.id), c]))

    const entries = (storeChannels || []).map((storeChannel) => {
        const id = storeChannel.idChannel || (storeChannel.channel && storeChannel.channel.id)
        const configured = configuredById.get(String(id))
        const reference = configured || storeChannel.channel || {}

        return {
            storeChannel,
            isActive: configured ? !!configured.isActive : true,
            realName: reference.getRealName ? reference.getRealName() : (reference.name || ''),
            name: (storeChannel.channel && storeChannel.channel.name) || reference.name || '',
        }
    })

    entries.sort((a, b) => collator.compare(a.realName, b.realName) || collator.compare(a.name, b.name))

    return {
        active: entries.filter((e) => e.isActive).map((e) => e.storeChannel),
        inactive: entries.filter((e) => !e.isActive).map((e) => e.storeChannel),
    }
}
